module.exports = __webpack_public_path__ + "static/media/2.6c73f27f.JPG";